import { render, staticRenderFns } from "./BannersComponent.vue?vue&type=template&id=dfae7a3a"
import script from "./BannersComponent.vue?vue&type=script&lang=js"
export * from "./BannersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports